import RectangledLogo from './RectangledLogo';

export default RectangledLogo;
